export const RadarIcon = () => (
  <svg
    className="menu-icon"
    width="50px"
    height="50px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <g>
          <path
            d="M256,0C114.841,0,0,114.841,0,256s114.841,256,256,256s256-114.841,256-256S397.159,0,256,0z M256,495.832
				C123.756,495.832,16.168,388.244,16.168,256S123.756,16.168,256,16.168c132.243,0,239.832,107.588,239.832,239.832
				S388.243,495.832,256,495.832z"
          />
          <path
            d="M256,36.245C134.826,36.245,36.245,134.827,36.245,256S134.826,475.755,256,475.755S475.755,377.173,475.755,256
				S377.174,36.245,256,36.245z M247.915,459.412c-105.84-4.156-191.171-89.487-195.326-195.327h36.938
				c1.461,30.416,11.13,59.636,28.23,84.963c-3.235,4.75-5.129,10.484-5.129,16.651c0,16.356,13.307,29.663,29.663,29.663
				c5.789,0,11.192-1.673,15.762-4.552c26.443,19.28,57.298,30.139,89.862,31.683V459.412z M128.798,365.698
				c0-7.441,6.052-13.494,13.494-13.494c7.441,0,13.494,6.053,13.494,13.494c0,7.441-6.053,13.494-13.494,13.494
				C134.851,379.193,128.798,373.139,128.798,365.698z M247.916,406.302c-28.553-1.5-55.624-10.947-78.977-27.588
				c1.928-3.932,3.016-8.349,3.016-13.017c0-16.354-13.307-29.662-29.663-29.662c-4.287,0-8.36,0.922-12.043,2.564
				c-14.713-22.32-23.113-47.894-24.531-74.517h46.569c3.933,50.927,44.7,91.694,95.629,95.628V406.302z M247.916,343.469
				c-42.003-3.852-75.533-37.382-79.385-79.385h79.385V343.469z M247.916,247.916h-79.385c3.852-42.003,37.382-75.533,79.385-79.385
				V247.916z M247.916,152.287c-50.928,3.933-91.695,44.7-95.629,95.629h-46.591c4.073-76.577,65.643-138.147,142.22-142.221
				V152.287z M247.916,89.507c-85.494,4.104-154.304,72.914-158.407,158.408h-36.92c4.155-105.841,89.487-191.171,195.327-195.327
				V89.507z M264.084,52.588c105.841,4.156,191.172,89.487,195.327,195.327h-36.941c-1.374-28.471-9.987-55.998-25.14-80.179
				c3.673-4.938,5.85-11.052,5.85-17.665c0-16.356-13.308-29.664-29.664-29.664c-5.518,0-10.686,1.519-15.116,4.154
				c-27.023-21.087-60.156-33.367-94.317-35.048V52.588z M387.014,150.071c0,7.441-6.053,13.494-13.495,13.494
				c-7.441,0-13.495-6.053-13.495-13.494c0-7.441,6.053-13.495,13.495-13.495C380.959,136.576,387.014,142.629,387.014,150.071z
				 M264.084,105.706c30.049,1.637,59.182,12.353,83.144,30.653c-2.149,4.105-3.373,8.768-3.373,13.713
				c0,16.356,13.308,29.663,29.664,29.663c3.859,0,7.543-0.748,10.928-2.094c13.033,21.284,20.504,45.367,21.835,70.277h-46.57
				v-0.001c-3.933-50.928-44.7-91.695-95.628-95.629V105.706z M264.084,168.531c42.002,3.852,75.532,37.382,79.385,79.385h-79.385
				V168.531z M264.084,359.705c26.06-2.054,50.682-13.971,68.525-33.402c3.02-3.289,2.803-8.402-0.486-11.422
				c-3.289-3.02-8.403-2.803-11.424,0.486c-14.786,16.102-35.078,26.074-56.615,28.089v-79.372h79.401
				c-0.95,10.47-3.747,20.56-8.363,30.088c-1.948,4.017-0.268,8.853,3.75,10.801c4.019,1.948,8.853,0.268,10.799-3.75
				c5.692-11.745,9.051-24.206,10.038-37.139h46.594c-4.073,76.576-65.644,138.146-142.22,142.22V359.705z M264.084,459.412v-36.92
				c85.494-4.104,154.304-72.913,158.407-158.407h36.92C455.256,369.925,369.925,455.255,264.084,459.412z"
          />
        </g>
      </g>
    </g>
  </svg>
);
